export const chapterStructure = {
  "Chapter Leadership": {
    description: "Oversees all strategic operations and supports internal chapter logistics.",
    roles: [
      { role: "Chapter Executive" },
      { role: "Operational Advisor" },
      { role: "Chief of Staff" },
      { role: "Interim Marketing Lead" },
      { role: "Finance Lead" },
    ],
  },
  "Programs Leadership": {
    description: "Leads programs like the Research Track and Training initiatives across the chapter.",
    roles: [
      { role: "Programs Executive" },
      { role: "Research Lead" },
      { role: "Training Lead" },
    ],
  },
  "Research Track Support": {
    description: "Supports student researchers through the cohort-based peer advising structure.",
    roles: [
      { role: "Senior Peer Advisor" },
      { role: "Peer Advisor" },
      { role: "Researcher" },
    ],
  },
  "Chapter Lab Support": {
    description: "Organized by lab focus, these roles support quantum, domain, or hybrid research execution.",
    roles: [
      { role: "Quantum Focused Researcher" },
      { role: "Domain Focused Researcher" },
      { role: "Quantum & Domain Focused Researcher" },
      { role: "Quantum-Chemistry Researcher" },
    ],
  }
};